import axios from 'axios';

const root = 'api/workflow/metrics/';

// Django reads repeated params via getlist('batch_id'), i.e. batch_id=1&batch_id=2.
// Axios's default array style (batch_id[]=1) would silently filter nothing, so
// every metrics fetcher serialises arrays repeat-style.
function serialiseParams(params) {
    const searchParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value === undefined || value === null) return;
        if (Array.isArray(value)) {
            value.forEach((entry) => searchParams.append(key, entry));
        } else {
            searchParams.append(key, value);
        }
    });
    return searchParams.toString();
}

const get = (path) => (params) =>
    axios.get(`${root}${path}/`, { params, paramsSerializer: { serialize: serialiseParams } });

export const workflowMetrics = {
    overview: get('overview'),
    annotators: get('annotators'),
    reviewers: get('reviewers'),
    managers: get('managers'),
    batches: get('batches'),
    userActivity: get('user-activity'),
    syncHealth: get('sync-health'),
    batchTasks: get('batch-tasks'),
    batchRounds: get('batch-rounds'),
    batchUsers: get('batch-users'),
    events: get('events'),
    taskTimeline: get('task-timeline'),
    batchTimeline: get('batch-timeline'),
};
